/** Import capacity is independent of the number of properties admitted to planning. */
export const BATCH_UPLOAD_MAX_ROWS = 10_000
export const BATCH_UPLOAD_MAX_BYTES = 25 * 1024 * 1024
export const BATCH_UPLOAD_MAX_PROPERTIES = 500

export const validateBatchUploadPropertyLimit = (propertyIds: readonly string[]): string | null => {
  const propertyCount = new Set(propertyIds.filter(Boolean)).size
  const excess = propertyCount - BATCH_UPLOAD_MAX_PROPERTIES

  if (excess <= 0) return null

  return `Bitte entfernen Sie noch ${excess.toLocaleString("de-DE")} ${excess === 1 ? "Liegenschaft" : "Liegenschaften"} aus diesem Durchgang, bevor Sie mit der Terminplanung fortfahren.`
}
